export const DATE_GENERAL_FORMAT = 'dd.MM.yyyy HH:mm:ss:SSS';
